/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_Montdor/layout/core'
import {
  MixedWidget10,
  MixedWidget11,
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget5,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
} from '../../../_Montdor/partials/widgets'
import {MixedWidget2} from './components/MixedWidget2'
import {ListsWidget2_2} from './components/ListsWidget2_2'
import {ListsWidget6_2} from './components/ListsWidget6_2'
import {ListsWidget4_2} from './components/ListsWidget4_2'
import {ListsWidget3_2} from './components/ListsWidget3_2'
import {AdminCount} from './components/for-admin/AdminCount'
import {UserModel} from '../../modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../setup'
import {SalesCountPage} from './components/for-sales/SalesCountPage'
import {PieChartjs} from './components/PieChartjs'
import {ColumnChartjs} from './components/ColumnChartjs'
import {TablesSalesQuotCount} from './components/TablesSalesQuotCount'
import {
  Get_Chart_QuotationCountApi,
  GetDashBoardDataForChartAndGraph_ByMonthYear_StateWiseApi,
  GetDashBoardDataForChartAndGraph_ByMonthYearApi,
  GetNewProjectListByMonthYearApi,
  getNewProjectListByMonthYearStateWise,
} from '../../modules/dashboard-page/DashboardCRUD'
import {toast} from 'react-toastify'
import {ThisMonthColumnCharts} from './components/ThisMonthColumnCharts'
import {ThisYearPieChartjs} from './components/ThisYearPieChartjs'
import {SalesNameQuotCountTotal} from './components/SalesNameQuotCountTotal'
import {MonthDropdownData, YearsDropdownData} from '../other-dropDowns/otherDropDowns'
import {NewProjectList} from './components/NewProjectList'
import {INewProjectModel} from '../../models/dashboard-page/IDashboardModel'
import moment from 'moment'
import {StateGujaratColumnChart} from './components/StateGujaratColumnChart'
import {StateMaharastraColumnChart} from './components/StateMaharastraColumnChart'
import {StateGujaratPieChart} from './components/StateGujaratPieChart'
import {StateMaharastraPieChart} from './components/StateMaharastraPieChart'
// import { DesignersQuotCountTotal } from './components/DesignersQuotCountTotal'

// Define interfaces for API responses
interface DashboardApiResponse {
  isSuccess: boolean
  message: string
  lablesNames: string[]
  totalCnt: number[]
  dailyCount: number[]
  statusName: string[]
  monthlyStatusCnt: number[]
  yearStatusCnt: number[]
  monthlyStatusCnt_GJ?: number[]
  yearStatusCnt_GJ?: number[]
  monthlyStatusCnt_MH?: number[]
  yearStatusCnt_MH?: number[]
  responseObject?: any // For the filtered data response
}
interface NewProjectREsponse {
  isSuccess: boolean
  message: string
  gjprojectTypeTitleWithCount: string[]
  mhprojectTypeTitleWithCount: string[]
  noOfProject: number[]
  stateName: string[]
  stateID: number[]
  responseObject?: any // For the filtered data response
}

interface IState {
  loading: boolean
  dailyCount: number[]
  lablesNames: string[]
  totalCnt: number[]
  statusNames: string[]
  montCount: number[]
  yearCnt: number[]
  selYearID: number
  selMonthID: number
  saleQutContData?: any // Optional field for filtered data
  ProjectData: INewProjectModel[]
  noOfProject: number[]
  gjprojectTypeTitleWithCount: string[]
  mhprojectTypeTitleWithCount: string[]
  arrayStateID: number[]
  arrayStateName: string[]
  gjRespObject: number[]
  mhRespObject: number[]
  selmonthName: string
  selYearName: string
  gjLabels: string[]
  gjMonthlyCounts: string[]
  gjYearlyCounts: string[]
  mhLabels: string[]
  mhMonthlyCounts: string[]
  mhYearlyCounts: string[]
}

// Chart component props interface
interface ChartProps {
  className?: string
  lablesNames: string[]
  totalCnt?: number[]
  dailyCount?: number[]
  chartColor?: string
  chartHeight?: string
  strokeColor?: string
}

const DashboardPage: FC = () => (
  <>
    <div className='container-fluid px-3 px-md-5'>
      <div className='row g-4'>
        <div className='col-12 col-md-6 col-xl-4'>
          <MixedWidget2
            className='card-xl-stretch mb-xl-8'
            chartColor='danger'
            chartHeight='100px'
            strokeColor='#cb1e46'
          />
        </div>
        <div className='col-12 col-md-6 col-xl-4'>
          <ListsWidget6_2 className='card-xl-stretch mb-xl-8' />
          <ListsWidget4_2 className='card-xl-stretch mb-5 mb-xl-8' items={5} />
        </div>
        <div className='col-12 col-md-12 col-xl-4'>
          <ListsWidget4_2 className='card-xl-stretch mb-5 mb-xl-8' items={5} />
        </div>
      </div>
    </div>
  </>
)
const currentDate = new Date()

const currentMonth = currentDate.getMonth() + 1 // Months are 0-indexed in JS
const currentYear = currentDate.getFullYear()
const AdminDashboardPage: FC = () => {
  const [state, setState] = useState<IState>({
    loading: false,
    dailyCount: [],
    lablesNames: [],
    totalCnt: [],
    statusNames: [],
    montCount: [],
    yearCnt: [],
    selYearID: moment().year(), // Set current year as default
    selMonthID: moment().month() + 1, // Set current month as default

    ProjectData: [] as INewProjectModel[],
    noOfProject: [],
    gjprojectTypeTitleWithCount: [],
    mhprojectTypeTitleWithCount: [],
    gjLabels: [],
    gjMonthlyCounts: [],
    gjYearlyCounts: [],
    mhLabels: [],
    mhMonthlyCounts: [],
    mhYearlyCounts: [],
    arrayStateID: [],
    arrayStateName: [],
    gjRespObject: [],
    mhRespObject: [],
    selmonthName: '',
    selYearName: '',
  })

  useEffect(() => {
    fetchAdminCountList()
    // newProjectList(state.selMonthID,state.selYearID)
  }, [])
  const SalesPersonWiseMonthYearQuotationCountData = (selMonthID: number, selYearID: number) => {
    setState((prev) => ({...prev, loading: true}))

    // GetDashBoardDataForChartAndGraph_ByMonthYearApi(selMonthID, selYearID)
    GetDashBoardDataForChartAndGraph_ByMonthYear_StateWiseApi(selMonthID, selYearID)
      .then(async (response) => {
        const responseData: DashboardApiResponse = response.data

        if (responseData.isSuccess) {
          // Now also fetch new project list
          // await newProjectList(responseData, selMonthID, selYearID)
          await newStateWiseProjectList(responseData, selMonthID, selYearID)
        } else {
          toast.error(responseData.message)
          setState((prev) => ({...prev, loading: false}))
        }
      })
      .catch((error) => {
        toast.error(error.message || 'Failed to fetch filtered data')
        setState((prev) => ({...prev, loading: false}))
      })
  }

  const YearModeValue = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const tmpPaymentModeID = parseInt(event.target.value)
    SalesPersonWiseMonthYearQuotationCountData(state.selMonthID, tmpPaymentModeID)
  }

  const MonthModeValue = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const tmpPaymentModeID = parseInt(event.target.value)
    SalesPersonWiseMonthYearQuotationCountData(tmpPaymentModeID, state.selYearID)
  }

  // const fetchAdminCountList = async () => {
  //   try {
  //     setState((prev) => ({...prev, loading: true}))

  //     const response = await Get_Chart_QuotationCountApi()
  //     const responseData: DashboardApiResponse = response.data

  //     if (responseData.isSuccess) {
  //       // Call second API only after first is successful
  //       // await newProjectList(responseData, state.selMonthID, state.selYearID)
  //       await newStateWiseProjectList(responseData, state.selMonthID, state.selYearID)
  //     } else {
  //       toast.error(responseData.message)
  //       setState((prev) => ({...prev, loading: false}))
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message || 'Failed to fetch dashboard data')
  //     setState((prev) => ({...prev, loading: false}))
  //   }
  // }

  //--------------- State Wise monthly project -------------------
  const fetchAdminCountList = async () => {
    try {
      setState((prev) => ({...prev, loading: true}))

      const response = await GetDashBoardDataForChartAndGraph_ByMonthYear_StateWiseApi(
        state.selMonthID,
        state.selYearID
      )

      const responseData: DashboardApiResponse = response.data

      if (responseData.isSuccess) {
        await newStateWiseProjectList(responseData, state.selMonthID, state.selYearID)
        // const {
        //   lablesNames,
        //   totalCnt,
        //   dailyCount,
        //   statusName,
        //   monthlyStatusCnt_GJ,
        //   yearStatusCnt_GJ,
        //   monthlyStatusCnt_MH,
        //   yearStatusCnt_MH,
        // } = responseData

        // setState((prev: any) => ({
        //   ...prev,
        //   loading: false,
        //   lablesNames,
        //   totalCnt,
        //   dailyCount,
        //   statusNames: statusName,
        //   gujaratStatus: {
        //     labels: statusName,
        //     monthlyCounts: monthlyStatusCnt_GJ,
        //     yearlyCounts: yearStatusCnt_GJ,
        //   },
        //   maharashtraStatus: {
        //     labels: statusName,
        //     monthlyCounts: monthlyStatusCnt_MH,
        //     yearlyCounts: yearStatusCnt_MH,
        //   },
        //   // Optional: update these if coming from API
        //   // gjprojectTypeTitleWithCount,
        //   // mhprojectTypeTitleWithCount,
        // }))
      } else {
        toast.error(responseData.message)
        setState((prev) => ({...prev, loading: false}))
      }
    } catch (error: any) {
      toast.error(error.message || 'Failed to fetch dashboard data')
      setState((prev) => ({...prev, loading: false}))
    }
  }

  // const newProjectList = async (
  //   dashboardData: DashboardApiResponse,
  //   selMonthID: number,
  //   selYearID: number
  // ) => {
  //   try {
  //     const response = await GetNewProjectListByMonthYearApi(selMonthID, selYearID)
  //     const responseData: NewProjectREsponse = response.data

  //     const monthName =
  //       selMonthID > 0 && selMonthID <= 12
  //         ? moment()
  //             .month(selMonthID - 1)
  //             .format('MMMM')
  //         : 'Unknown'
  //     const year = selYearID > 0 ? selYearID.toString() : 'Unknown' // Convert to string for selYearName
  //     if (responseData.isSuccess) {
  //       setState({
  //         ...state,

  //         dailyCount: dashboardData.dailyCount,
  //         lablesNames: dashboardData.lablesNames,
  //         totalCnt: dashboardData.totalCnt,
  //         statusNames: dashboardData.statusName,
  //         montCount: dashboardData.monthlyStatusCnt,
  //         yearCnt: dashboardData.yearStatusCnt,
  //         noOfProject: responseData.noOfProject,
  //         projectTypeTitle: responseData.projectTypeTitle,
  //         selMonthID: selMonthID,
  //         selYearID: selYearID,
  //         selmonthName: monthName,
  //         selYearName: year,
  //         loading: false,
  //       })
  //     } else {
  //       toast.error(responseData.message)
  //       setState((prev) => ({...prev, loading: false}))
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message || 'Failed to fetch project data')
  //     setState((prev) => ({...prev, loading: false}))
  //   }
  // }

  // -------------State wise Project ---------------

  const newStateWiseProjectList = async (
    dashboardData: DashboardApiResponse,
    selMonthID: number,
    selYearID: number
  ) => {
    try {
      const response = await getNewProjectListByMonthYearStateWise(selMonthID, selYearID)
      const responseData: NewProjectREsponse = response.data
      const {
        lablesNames,
        totalCnt,
        dailyCount,
        statusName,
        monthlyStatusCnt_GJ,
        yearStatusCnt_GJ,
        monthlyStatusCnt_MH,
        yearStatusCnt_MH,
      } = dashboardData
      console.log('', monthlyStatusCnt_GJ, 'mh', monthlyStatusCnt_MH)

      // setState((prev: any) => ({
      //   ...prev,
      //   loading: false,
      //   lablesNames,
      //   totalCnt,
      //   dailyCount,
      //   statusNames: statusName,
      //   gujaratStatus: {
      //     labels: statusName,
      //     monthlyCounts: monthlyStatusCnt_GJ,
      //     yearlyCounts: yearStatusCnt_GJ,
      //   },
      //   maharashtraStatus: {
      //     labels: statusName,
      //     monthlyCounts: monthlyStatusCnt_MH,
      //     yearlyCounts: yearStatusCnt_MH,
      //   },
      //   // Optional: update these if coming from API
      //   // gjprojectTypeTitleWithCount,
      //   // mhprojectTypeTitleWithCount,
      // }))
      const apiResponse: any = response.data
      // console.log('dashboardData', dashboardData)
      const monthName =
        selMonthID > 0 && selMonthID <= 12
          ? moment()
              .month(selMonthID - 1)
              .format('MMMM')
          : 'Unknown'
      const year = selYearID > 0 ? selYearID.toString() : 'Unknown' // Convert to string for selYearName
      if (responseData.isSuccess) {
        // Step 1: Extract unique project types in order
        const projectTypeTitle: string[] = []

        apiResponse.responseObject.forEach((item: any) => {
          const name = item.projectTypeName.trim()
          if (!projectTypeTitle.includes(name)) {
            projectTypeTitle.push(name)
          }
        })

        // Step 2: Create state-wise project count map per project type (indexed array)
        const stateMap: Record<number, number[]> = {}

        apiResponse.responseObject.forEach((item: any) => {
          const {stateID, projectTypeName, noOfProject} = item
          const trimmedType = projectTypeName.trim()
          const typeIndex = projectTypeTitle.indexOf(trimmedType)

          if (!stateMap[stateID]) {
            stateMap[stateID] = new Array(projectTypeTitle.length).fill(0)
          }

          if (typeIndex !== -1) {
            stateMap[stateID][typeIndex] += noOfProject
          }
        })

        // Step 3: Get Gujarat and Maharashtra project counts
        const gjNoOfProj = stateMap[1] || new Array(projectTypeTitle.length).fill(0)
        const mhNoOfProject = stateMap[15] || new Array(projectTypeTitle.length).fill(0)

        // Step 4: Build state-wise projectTypeTitleWithCount based on actual project counts
        const gjprojectTypeTitleWithCount = projectTypeTitle.map((type, index) => {
          return `${type} (${gjNoOfProj[index]})`
        })

        const mhprojectTypeTitleWithCount = projectTypeTitle.map((type, index) => {
          return `${type} (${mhNoOfProject[index]})`
        })

        // ✅ Output
        // console.log('projectTypeTitle:', projectTypeTitle)
        // console.log('gjprojectTypeTitleWithCount:', gjprojectTypeTitleWithCount)
        // console.log('mhprojectTypeTitleWithCount:', mhprojectTypeTitleWithCount)
        // console.log('gjNoOfProj:', gjNoOfProj)
        // console.log('mhNoOfProject:', mhNoOfProject)
        // console.log('monthlyStatusCnt_GJ:', monthlyStatusCnt_GJ)
        // console.log('statusName:', statusName)
        // console.log('statusName:', (monthlyStatusCnt_GJ ?? []).map(String))
        // console.log('responseData.stateID:', responseData.stateID)
        // console.log('responseData.stateID.includes(1):', responseData.stateID.includes(1))
        // console.log('state.gjLabels.length:', statusName.length)
        // console.log('statusName:', statusName.length)

        setState({
          ...state,
          gjLabels: statusName,
          mhLabels: statusName,
          gjMonthlyCounts: (monthlyStatusCnt_GJ ?? []).map(String),
          mhMonthlyCounts: (monthlyStatusCnt_MH ?? []).map(String),
          dailyCount: dashboardData.dailyCount,
          lablesNames: dashboardData.lablesNames,
          totalCnt: dashboardData.totalCnt,
          statusNames: dashboardData.statusName,
          // montCount: dashboardData.monthlyStatusCnt,
          // yearCnt: dashboardData.yearStatusCnt,
          noOfProject: responseData.noOfProject,
          arrayStateID: responseData.stateID,
          arrayStateName: responseData.stateName,
          gjprojectTypeTitleWithCount: gjprojectTypeTitleWithCount,
          mhprojectTypeTitleWithCount: mhprojectTypeTitleWithCount,
          gjRespObject: gjNoOfProj,
          mhRespObject: mhNoOfProject,
          selMonthID: selMonthID,
          selYearID: selYearID,
          selmonthName: monthName,
          selYearName: year,
          loading: false,
        })
      } else {
        toast.error(responseData.message)
        setState((prev) => ({...prev, loading: false}))
      }
    } catch (error: any) {
      toast.error(error.message || 'Failed to fetch project data')
      setState((prev) => ({...prev, loading: false}))
    }
  }

  return (
    <>
      <div className='row gy-1 gx-xl-2 mb-4'>
        <div className='d-flex flex-row justify-content-end align-items-end'>
          <div className='me-3'>
            <select
              className='form-select form-select-white'
              onChange={MonthModeValue}
              value={state.selMonthID}
            >
              <option value={0}>Select Month</option>
              {MonthDropdownData.map((data, index) => (
                <option key={index} value={data.MonthID}>
                  {data.MonthName}
                </option>
              ))}
            </select>
          </div>
          <div className='me-3'>
            <select
              className='form-select form-select-white'
              onChange={YearModeValue}
              value={state.selYearID}
            >
              <option value={0}>Select Year</option>
              {YearsDropdownData.map((data, index) => (
                <option key={index} value={data}>
                  {data}
                </option>
              ))}
            </select>
          </div>
        </div>
        {state.loading ? (
          <div className='text-center py-10'>
            <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
          </div>
        ) : (
          <>
            {/* <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <PieChartjs
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.totalCnt}
                  lablesNames={state.lablesNames}
                />
              )}
            </div>
            <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <ThisYearPieChartjs
                  className='card-xl-stretch'
                  totalCnt={state.yearCnt}
                  lablesNames={state.statusNames}
                />
              )}
            </div> */}
            <div className='col-xl-6'>
              {state.lablesNames.length > 0 && (
                <ColumnChartjs
                  className='card-xl-stretch mb-xl-8'
                  dailyCount={state.dailyCount}
                  lablesNames={state.lablesNames}
                />
              )}
            </div>
            <div className='col-xl-6'>
              <StateGujaratColumnChart
                className='card-xl-stretch'
                dailyCount={state.gjMonthlyCounts}
                lablesNames={state.gjLabels}
                selMonthID={state.selMonthID}
                selmonthName={state.selmonthName}
                selYearID={state.selYearID}
              />
              {/* ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-warning'>
                      <span className='text-success'>Gujarat</span> ({state.selmonthName}{' '}
                      {state.selYearName}) This Month Projects
                    </span>
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )} */}
            </div>

            {/*<div className='col-xl-4'>
             
                <StateMaharastraColumnChart
                  className='card-xl-stretch'
                  dailyCount={state.mhMonthlyCounts}
                  lablesNames={state.mhLabels}
                  selMonthID={state.selMonthID}
                  selmonthName={state.selmonthName}
                  selYearID={state.selYearID}
                />*/}
            {/* ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-warning'>
                      <span className='text-success'>Maharashtra</span> ({state.selmonthName}{' '}
                      {state.selYearName}) This Month Projects
                    </span>
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )} 
            </div>*/}

            {/* <div className='col-xl-4'>
              {state.projectTypeTitle.length > 0 && (
                <NewProjectList
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.noOfProject}
                  lablesNames={state.projectTypeTitle.map((title, index) => {
                    const count = state.noOfProject[index] ?? 0
                    return `${title} (${count})`
                  })}
                  
                />
              )}
            </div> */}

            {/* /start commit by State wise */}
            {/* <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <ThisMonthColumnCharts
                  className='card-xl-stretch'
                  dailyCount={state.montCount}
                  lablesNames={state.statusNames}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              )}
            </div> */}

            {/* <div className='col-xl-4'>
              {state.projectTypeTitle.length > 0 ? (
                <NewProjectList
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.noOfProject}
                  lablesNames={state.projectTypeTitle.map((title, index) => {
                    const count = state.noOfProject[index] ?? 0
                    return `${title} (${count})`
                  })}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-3 text-info'>
                      {' '}
                      {state.selmonthName} {state.selYearName} New Projects
                    </span>

                //    <span className='text-muted fw-bold fs-7'>More than 400 new members</span>
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div> */}
            {/* /end commit */}

            <div className='col-xl-6'>
              {state.arrayStateID.includes(1) && state.gjprojectTypeTitleWithCount.length > 0 ? (
                <StateGujaratPieChart
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.gjRespObject}
                  lablesNames={state.gjprojectTypeTitleWithCount}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-info'>
                      {/* <span className='text-success fs-5'></span> {'('} */}
                      {state.selmonthName} {state.selYearName}
                      {/* {')'}  */} New Projects
                    </span>

                    {/* //<span className='text-muted fw-bold fs-7'>More than 400 new members</span> */}
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div>
            {/* //Maharastra pie chart */}
            {/*  <div className='col-xl-4'>
              {state.arrayStateID.includes(15) && state.mhprojectTypeTitleWithCount.length > 0 ? (
                <StateMaharastraPieChart
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.mhRespObject}
                  lablesNames={state.mhprojectTypeTitleWithCount}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-info'>
                      <span className='text-success fs-5'>Maharastra</span> {'('}
                      {state.selmonthName} {state.selYearName}
                      {')'} New Projects
                    </span>

                   
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div>*/}

            <div className='col-xl-6'>
              {state.lablesNames.length > 0 && (
                <SalesNameQuotCountTotal
                  className='card-xl-stretch'
                  lablesNames={state.lablesNames}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              )}
            </div>
            {/* <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <DesignersQuotCountTotal
                  className='card-xl-stretch'
                  lablesNames={state.lablesNames}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              )}
            </div> */}
          </>
        )}
      </div>

      <div className='row gy-5 g-xl-8'>
        <div className='col-xxl-12 col-12'>
          {!state.loading && state.lablesNames.length > 0 && (
            <TablesSalesQuotCount
              key={`${state.selMonthID}-${state.selYearID}`}
              className='card-xl-stretch mb-xl-8'
              lablesNames={state.lablesNames}
              selMonthID={state.selMonthID}
              selYearID={state.selYearID}
            />
          )}
        </div>
      </div>

      <div className='row gy-5 g-xl-8'>
        <div className='col-xxl-12 col-12'>
          <AdminCount
            className='card-xl-stretch mb-xl-8'
            chartColor='danger'
            chartHeight='100px'
            strokeColor='#cb1e46'
          />
        </div>
      </div>
    </>
  )
}

const SalesManagerDashboardPage: FC = () => {
  const [state, setState] = useState<IState>({
    loading: false,
    dailyCount: [],
    lablesNames: [],
    totalCnt: [],
    statusNames: [],
    montCount: [],
    yearCnt: [],
    // selYearID: 0,
    // selMonthID: 0,
    ProjectData: [] as INewProjectModel[],
    noOfProject: [],
    gjprojectTypeTitleWithCount: [],
    mhprojectTypeTitleWithCount: [],
    gjLabels: [],
    gjMonthlyCounts: [],
    gjYearlyCounts: [],
    mhLabels: [],
    mhMonthlyCounts: [],
    mhYearlyCounts: [],
    arrayStateID: [],
    arrayStateName: [],
    gjRespObject: [],
    mhRespObject: [],
    selmonthName: '',
    selYearName: '',
    selYearID: moment().year(), // Set current year as default
    selMonthID: moment().month() + 1, // Set current month as default
  })

  useEffect(() => {
    fetchAdminCountList()
  }, [])

  const SalesPersonWiseMonthYearQuotationCountData = (selMonthID: number, selYearID: number) => {
    setState((prev) => ({...prev, loading: true}))

    // GetDashBoardDataForChartAndGraph_ByMonthYearApi(selMonthID, selYearID)
    GetDashBoardDataForChartAndGraph_ByMonthYear_StateWiseApi(selMonthID, selYearID)
      .then(async (response) => {
        const responseData: DashboardApiResponse = response.data

        if (responseData.isSuccess) {
          // Now also fetch new project list
          // await newProjectList(responseData, selMonthID, selYearID)
          await newStateWiseProjectList(responseData, selMonthID, selYearID)
        } else {
          toast.error(responseData.message)
          setState((prev) => ({...prev, loading: false}))
        }
      })
      .catch((error) => {
        toast.error(error.message || 'Failed to fetch filtered data')
        setState((prev) => ({...prev, loading: false}))
      })
  }

  const YearModeValue = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const tmpPaymentModeID = parseInt(event.target.value)
    SalesPersonWiseMonthYearQuotationCountData(state.selMonthID, tmpPaymentModeID)
  }

  const MonthModeValue = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const tmpPaymentModeID = parseInt(event.target.value)
    SalesPersonWiseMonthYearQuotationCountData(tmpPaymentModeID, state.selYearID)
  }
  // const fetchAdminCountList = async () => {
  //   try {
  //     setState((prev) => ({...prev, loading: true}))

  //     const response = await Get_Chart_QuotationCountApi()
  //     const responseData: DashboardApiResponse = response.data

  //     if (responseData.isSuccess) {
  //       // Call second API only after first is successful
  //       // await newProjectList(responseData, state.selMonthID, state.selYearID)
  //       await newStateWiseProjectList(responseData, state.selMonthID, state.selYearID)
  //     } else {
  //       toast.error(responseData.message)
  //       setState((prev) => ({...prev, loading: false}))
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message || 'Failed to fetch dashboard data')
  //     setState((prev) => ({...prev, loading: false}))
  //   }
  // }

  // const newProjectList = async (
  //   dashboardData: DashboardApiResponse,
  //   selMonthID: number,
  //   selYearID: number
  // ) => {
  //   try {
  //     const response = await GetNewProjectListByMonthYearApi(selMonthID, selYearID)
  //     const responseData: NewProjectREsponse = response.data

  //     if (responseData.isSuccess) {
  //       setState((prev) => ({
  //         ...prev,
  //         dailyCount: dashboardData.dailyCount,
  //         lablesNames: dashboardData.lablesNames,
  //         totalCnt: dashboardData.totalCnt,
  //         statusNames: dashboardData.statusName,
  //         montCount: dashboardData.monthlyStatusCnt,
  //         yearCnt: dashboardData.yearStatusCnt,
  //         noOfProject: responseData.noOfProject,
  //         projectTypeTitle: responseData.projectTypeTitle,
  //         selMonthID: selMonthID,
  //         selYearID: selYearID,
  //         loading: false,
  //       }))
  //     } else {
  //       toast.error(responseData.message)
  //       setState((prev) => ({...prev, loading: false}))
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message || 'Failed to fetch project data')
  //     setState((prev) => ({...prev, loading: false}))
  //   }
  // }
  // const newProjectList = async (
  //   dashboardData: DashboardApiResponse,
  //   selMonthID: number,
  //   selYearID: number
  // ) => {
  //   try {
  //     const response = await GetNewProjectListByMonthYearApi(selMonthID, selYearID)
  //     const responseData: NewProjectREsponse = response.data

  //     const monthName =
  //       selMonthID > 0 && selMonthID <= 12
  //         ? moment()
  //             .month(selMonthID - 1)
  //             .format('MMMM')
  //         : 'Unknown'
  //     const year = selYearID > 0 ? selYearID.toString() : 'Unknown' // Convert to string for selYearName
  //     if (responseData.isSuccess) {
  //       setState({
  //         ...state,

  //         dailyCount: dashboardData.dailyCount,
  //         lablesNames: dashboardData.lablesNames,
  //         totalCnt: dashboardData.totalCnt,
  //         statusNames: dashboardData.statusName,
  //         montCount: dashboardData.monthlyStatusCnt,
  //         yearCnt: dashboardData.yearStatusCnt,
  //         noOfProject: responseData.noOfProject,
  //         projectTypeTitle: responseData.projectTypeTitle,
  //         selMonthID: selMonthID,
  //         selYearID: selYearID,
  //         selmonthName: monthName,
  //         selYearName: year,
  //         loading: false,
  //       })
  //     } else {
  //       toast.error(responseData.message)
  //       setState((prev) => ({...prev, loading: false}))
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message || 'Failed to fetch project data')
  //     setState((prev) => ({...prev, loading: false}))
  //   }
  // }

  const fetchAdminCountList = async () => {
    try {
      setState((prev) => ({...prev, loading: true}))

      const response = await GetDashBoardDataForChartAndGraph_ByMonthYear_StateWiseApi(
        state.selMonthID,
        state.selYearID
      )

      const responseData: DashboardApiResponse = response.data

      if (responseData.isSuccess) {
        await newStateWiseProjectList(responseData, state.selMonthID, state.selYearID)
        // const {
        //   lablesNames,
        //   totalCnt,
        //   dailyCount,
        //   statusName,
        //   monthlyStatusCnt_GJ,
        //   yearStatusCnt_GJ,
        //   monthlyStatusCnt_MH,
        //   yearStatusCnt_MH,
        // } = responseData

        // setState((prev: any) => ({
        //   ...prev,
        //   loading: false,
        //   lablesNames,
        //   totalCnt,
        //   dailyCount,
        //   statusNames: statusName,
        //   gujaratStatus: {
        //     labels: statusName,
        //     monthlyCounts: monthlyStatusCnt_GJ,
        //     yearlyCounts: yearStatusCnt_GJ,
        //   },
        //   maharashtraStatus: {
        //     labels: statusName,
        //     monthlyCounts: monthlyStatusCnt_MH,
        //     yearlyCounts: yearStatusCnt_MH,
        //   },
        //   // Optional: update these if coming from API
        //   // gjprojectTypeTitleWithCount,
        //   // mhprojectTypeTitleWithCount,
        // }))
      } else {
        toast.error(responseData.message)
        setState((prev) => ({...prev, loading: false}))
      }
    } catch (error: any) {
      toast.error(error.message || 'Failed to fetch dashboard data')
      setState((prev) => ({...prev, loading: false}))
    }
  }

  const newStateWiseProjectList = async (
    dashboardData: DashboardApiResponse,
    selMonthID: number,
    selYearID: number
  ) => {
    try {
      const response = await getNewProjectListByMonthYearStateWise(selMonthID, selYearID)
      const responseData: NewProjectREsponse = response.data
      const apiResponse: any = response.data
      const {
        lablesNames,
        totalCnt,
        dailyCount,
        statusName,
        monthlyStatusCnt_GJ,
        yearStatusCnt_GJ,
        monthlyStatusCnt_MH,
        yearStatusCnt_MH,
      } = dashboardData

      // setState((prev: any) => ({
      //   ...prev,
      //   loading: false,
      //   lablesNames,
      //   totalCnt,
      //   dailyCount,
      //   statusNames: statusName,
      //   gujaratStatus: {
      //     labels: statusName,
      //     monthlyCounts: monthlyStatusCnt_GJ,
      //     yearlyCounts: yearStatusCnt_GJ,
      //   },
      //   maharashtraStatus: {
      //     labels: statusName,
      //     monthlyCounts: monthlyStatusCnt_MH,
      //     yearlyCounts: yearStatusCnt_MH,
      //   },
      //   // Optional: update these if coming from API
      //   // gjprojectTypeTitleWithCount,
      //   // mhprojectTypeTitleWithCount,
      // }))
      const monthName =
        selMonthID > 0 && selMonthID <= 12
          ? moment()
              .month(selMonthID - 1)
              .format('MMMM')
          : 'Unknown'
      const year = selYearID > 0 ? selYearID.toString() : 'Unknown' // Convert to string for selYearName
      if (responseData.isSuccess) {
        // Step 1: Extract unique project types in order
        const projectTypeTitle: string[] = []
        // Step 2: Create state-wise project count map per project type (indexed array)
        const stateMap: Record<number, number[]> = {}

        apiResponse.responseObject.forEach((item: any) => {
          const {stateID, projectTypeName, noOfProject} = item
          const trimmedType = projectTypeName.trim()
          const typeIndex = projectTypeTitle.indexOf(trimmedType)

          if (!stateMap[stateID]) {
            stateMap[stateID] = new Array(projectTypeTitle.length).fill(0)
          }

          if (typeIndex !== -1) {
            stateMap[stateID][typeIndex] += noOfProject
          }
        })

        // Step 3: Get Gujarat and Maharashtra project counts
        const gjNoOfProj = stateMap[1] || new Array(projectTypeTitle.length).fill(0)
        const mhNoOfProject = stateMap[15] || new Array(projectTypeTitle.length).fill(0)

        // Step 4: Build state-wise projectTypeTitleWithCount based on actual project counts
        const gjprojectTypeTitleWithCount = projectTypeTitle.map((type, index) => {
          return `${type} (${gjNoOfProj[index]})`
        })

        const mhprojectTypeTitleWithCount = projectTypeTitle.map((type, index) => {
          return `${type} (${mhNoOfProject[index]})`
        })

        // ✅ Output
        console.log('projectTypeTitle:', projectTypeTitle)
        console.log('gjprojectTypeTitleWithCount:', gjprojectTypeTitleWithCount)
        console.log('mhprojectTypeTitleWithCount:', mhprojectTypeTitleWithCount)
        console.log('gjNoOfProj:', gjNoOfProj)
        console.log('mhNoOfProject:', mhNoOfProject)

        setState({
          ...state,

          gjLabels: statusName,
          mhLabels: statusName,
          gjMonthlyCounts: (monthlyStatusCnt_GJ ?? []).map(String),
          mhMonthlyCounts: (monthlyStatusCnt_MH ?? []).map(String),
          dailyCount: dashboardData.dailyCount,
          lablesNames: dashboardData.lablesNames,
          totalCnt: dashboardData.totalCnt,
          statusNames: dashboardData.statusName,
          // montCount: dashboardData.monthlyStatusCnt,
          // yearCnt: dashboardData.yearStatusCnt,
          noOfProject: responseData.noOfProject,
          gjRespObject: gjNoOfProj,
          mhRespObject: mhNoOfProject,
          gjprojectTypeTitleWithCount: gjprojectTypeTitleWithCount,
          mhprojectTypeTitleWithCount: mhprojectTypeTitleWithCount,
          arrayStateID: responseData.stateID,
          arrayStateName: responseData.stateName,
          selMonthID: selMonthID,
          selYearID: selYearID,
          selmonthName: monthName,
          selYearName: year,
          loading: false,
        })
      } else {
        toast.error(responseData.message)
        setState((prev) => ({...prev, loading: false}))
      }
    } catch (error: any) {
      toast.error(error.message || 'Failed to fetch project data')
      setState((prev) => ({...prev, loading: false}))
    }
  }

  return (
    <>
      <div className='row gy-6 gx-xl-3'>
        <div className='d-flex flex-row justify-content-end align-items-end'>
          <div className='me-3'>
            <select
              className='form-select form-select-white'
              onChange={MonthModeValue}
              value={state.selMonthID}
            >
              <option value={0}>Select Month</option>
              {MonthDropdownData.map((data, index) => (
                <option key={index} value={data.MonthID}>
                  {data.MonthName}
                </option>
              ))}
            </select>
          </div>
          <div className='me-3'>
            <select
              className='form-select form-select-white'
              onChange={YearModeValue}
              value={state.selYearID}
            >
              <option value={0}>Select Year</option>
              {YearsDropdownData.map((data, index) => (
                <option key={index} value={data}>
                  {data}
                </option>
              ))}
            </select>
          </div>
        </div>
        {state.loading ? (
          <div className='text-center py-10'>
            <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
          </div>
        ) : (
          <>
            {/* <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <PieChartjs
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.totalCnt}
                  lablesNames={state.lablesNames}
                />
              )}
            </div>
            <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <ThisYearPieChartjs
                  className='card-xl-stretch'
                  totalCnt={state.yearCnt}
                  lablesNames={state.statusNames}
                />
              )}
            </div> */}
            <div className='col-xl-6'>
              {state.arrayStateID.includes(1) && state.gjLabels.length > 0 ? (
                <StateGujaratColumnChart
                  className='card-xl-stretch'
                  dailyCount={state.gjMonthlyCounts}
                  lablesNames={state.gjLabels}
                  selMonthID={state.selMonthID}
                  selmonthName={state.selmonthName}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-warning'>
                      <span className='text-success'></span> ({state.selmonthName}{' '}
                      {state.selYearName}) Current Month Projects
                    </span>
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div>

            {/* <div className='col-xl-4'>
              {state.arrayStateID.includes(15) && state.mhLabels.length > 0 ? (
                <StateMaharastraColumnChart
                  className='card-xl-stretch'
                  dailyCount={state.mhMonthlyCounts}
                  lablesNames={state.mhLabels}
                  selMonthID={state.selMonthID}
                  selmonthName={state.selmonthName}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-warning'>
                      <span className='text-success'>Maharashtra</span> ({state.selmonthName}{' '}
                      {state.selYearName}) This Month Projects
                    </span>
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div> */}

            <div className='col-xl-6'>
              {state.lablesNames.length > 0 && (
                <ColumnChartjs
                  className='card-xl-stretch mb-xl-8'
                  dailyCount={state.dailyCount}
                  lablesNames={state.lablesNames}
                />
              )}
            </div>
            {/* start commit, for state wise colunm chart */}
            {/* <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <ThisMonthColumnCharts
                  className='card-xl-stretch'
                  dailyCount={state.montCount}
                  lablesNames={state.statusNames}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              )}
            </div> */}
            {/* end commit, */}
            {/* <div className='col-xl-4'>
              {state.projectTypeTitle.length > 0 && (
                <NewProjectList
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.noOfProject}
                  lablesNames={state.projectTypeTitle.map((title, index) => {
                    const count = state.noOfProject[index] ?? 0
                    return `${title} (${count})`
                  })}
                  
                />
              )}
            </div> */}

            {/* start commit, for state wise Pie chart */}

            {/* <div className='col-xl-4'>
              {state.projectTypeTitle.length > 0 ? (
                <NewProjectList
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.noOfProject}
                  lablesNames={state.projectTypeTitle.map((title, index) => {
                    const count = state.noOfProject[index] ?? 0
                    return `${title} (${count})`
                  })}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-3 text-info'>
                      {' '}
                      {state.selmonthName} {state.selYearName} New Projects
                    </span>

                    //<span className='text-muted fw-bold fs-7'>More than 400 new members</span>
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div> */}
            {/* end commit, */}
            {/* //Gujarat Pie  Chart */}
            <div className='col-xl-6'>
              {state.arrayStateID.includes(1) && state.gjprojectTypeTitleWithCount.length > 0 ? (
                <StateGujaratPieChart
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.gjRespObject}
                  lablesNames={state.gjprojectTypeTitleWithCount}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-info'>
                      <span className='text-success fs-5'></span>
                      {'('}
                      {state.selmonthName} {state.selYearName} {')'} New Projects
                    </span>

                    {/* //<span className='text-muted fw-bold fs-7'>More than 400 new members</span> */}
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div>
            {/* //Maharastra pie chart */}
            {/* <div className='col-xl-4'>
              {state.arrayStateID.includes(15) && state.mhprojectTypeTitleWithCount.length > 0 ? (
                <StateMaharastraPieChart
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.mhRespObject}
                  lablesNames={state.mhprojectTypeTitleWithCount}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-info'>
                      <span className='text-success fs-5'>Maharastra</span> {'('}
                      {state.selmonthName} {state.selYearName} {')'} New Projects
                    </span>

                  
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div> */}

            <div className='col-xl-6'>
              {state.lablesNames.length > 0 && (
                <SalesNameQuotCountTotal
                  className='card-xl-stretch'
                  lablesNames={state.lablesNames}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              )}
            </div>
          </>
        )}
      </div>

      <div className='row gy-5 g-xl-8'>
        <div className='col-xxl-12 col-12'>
          {!state.loading && state.lablesNames.length > 0 && (
            <TablesSalesQuotCount
              key={`${state.selMonthID}-${state.selYearID}`}
              className='card-xl-stretch mb-xl-8'
              lablesNames={state.lablesNames}
              selMonthID={state.selMonthID}
              selYearID={state.selYearID}
            />
          )}
        </div>
      </div>

      <div className='row gy-5 g-xl-8'>
        <div className='col-xxl-12 col-12'>
          <AdminCount
            className='card-xl-stretch mb-xl-8'
            chartColor='danger'
            chartHeight='100px'
            strokeColor='#cb1e46'
          />
        </div>
      </div>
    </>
  )
}
// ===============================================================================================================================
const DandEHeadDashboardPage: FC = () => {
  const [state, setState] = useState<IState>({
    loading: false,
    dailyCount: [],
    lablesNames: [],
    totalCnt: [],
    statusNames: [],
    montCount: [],
    yearCnt: [],
    // selYearID: 0,
    // selMonthID: 0,
    ProjectData: [] as INewProjectModel[],
    noOfProject: [],
    gjprojectTypeTitleWithCount: [],
    mhprojectTypeTitleWithCount: [],
    gjLabels: [],
    gjMonthlyCounts: [],
    gjYearlyCounts: [],
    mhLabels: [],
    mhMonthlyCounts: [],
    mhYearlyCounts: [],
    arrayStateID: [],
    arrayStateName: [],
    gjRespObject: [],
    mhRespObject: [],
    selmonthName: '',
    selYearName: '',
    selYearID: moment().year(), // Set current year as default
    selMonthID: moment().month() + 1, // Set current month as default
  })

  useEffect(() => {
    fetchAdminCountList()
  }, [])

  const SalesPersonWiseMonthYearQuotationCountData = (selMonthID: number, selYearID: number) => {
    setState((prev) => ({...prev, loading: true}))

    // GetDashBoardDataForChartAndGraph_ByMonthYearApi(selMonthID, selYearID)
    GetDashBoardDataForChartAndGraph_ByMonthYear_StateWiseApi(selMonthID, selYearID)
      .then(async (response) => {
        const responseData: DashboardApiResponse = response.data

        if (responseData.isSuccess) {
          // Now also fetch new project list
          // await newProjectList(responseData, selMonthID, selYearID)
          await newStateWiseProjectList(responseData, selMonthID, selYearID)
        } else {
          toast.error(responseData.message)
          setState((prev) => ({...prev, loading: false}))
        }
      })
      .catch((error) => {
        toast.error(error.message || 'Failed to fetch filtered data')
        setState((prev) => ({...prev, loading: false}))
      })
  }

  const YearModeValue = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const tmpPaymentModeID = parseInt(event.target.value)
    SalesPersonWiseMonthYearQuotationCountData(state.selMonthID, tmpPaymentModeID)
  }

  const MonthModeValue = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const tmpPaymentModeID = parseInt(event.target.value)
    SalesPersonWiseMonthYearQuotationCountData(tmpPaymentModeID, state.selYearID)
  }
  // const fetchAdminCountList = async () => {
  //   try {
  //     setState((prev) => ({...prev, loading: true}))

  //     const response = await Get_Chart_QuotationCountApi()
  //     const responseData: DashboardApiResponse = response.data

  //     if (responseData.isSuccess) {
  //       // Call second API only after first is successful
  //       // await newProjectList(responseData, state.selMonthID, state.selYearID)
  //       await newStateWiseProjectList(responseData, state.selMonthID, state.selYearID)
  //     } else {
  //       toast.error(responseData.message)
  //       setState((prev) => ({...prev, loading: false}))
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message || 'Failed to fetch dashboard data')
  //     setState((prev) => ({...prev, loading: false}))
  //   }
  // }

  // const newProjectList = async (
  //   dashboardData: DashboardApiResponse,
  //   selMonthID: number,
  //   selYearID: number
  // ) => {
  //   try {
  //     const response = await GetNewProjectListByMonthYearApi(selMonthID, selYearID)
  //     const responseData: NewProjectREsponse = response.data

  //     if (responseData.isSuccess) {
  //       setState((prev) => ({
  //         ...prev,
  //         dailyCount: dashboardData.dailyCount,
  //         lablesNames: dashboardData.lablesNames,
  //         totalCnt: dashboardData.totalCnt,
  //         statusNames: dashboardData.statusName,
  //         montCount: dashboardData.monthlyStatusCnt,
  //         yearCnt: dashboardData.yearStatusCnt,
  //         noOfProject: responseData.noOfProject,
  //         projectTypeTitle: responseData.projectTypeTitle,
  //         selMonthID: selMonthID,
  //         selYearID: selYearID,
  //         loading: false,
  //       }))
  //     } else {
  //       toast.error(responseData.message)
  //       setState((prev) => ({...prev, loading: false}))
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message || 'Failed to fetch project data')
  //     setState((prev) => ({...prev, loading: false}))
  //   }
  // }
  // const newProjectList = async (
  //   dashboardData: DashboardApiResponse,
  //   selMonthID: number,
  //   selYearID: number
  // ) => {
  //   try {
  //     const response = await GetNewProjectListByMonthYearApi(selMonthID, selYearID)
  //     const responseData: NewProjectREsponse = response.data

  //     const monthName =
  //       selMonthID > 0 && selMonthID <= 12
  //         ? moment()
  //             .month(selMonthID - 1)
  //             .format('MMMM')
  //         : 'Unknown'
  //     const year = selYearID > 0 ? selYearID.toString() : 'Unknown' // Convert to string for selYearName
  //     if (responseData.isSuccess) {
  //       setState({
  //         ...state,

  //         dailyCount: dashboardData.dailyCount,
  //         lablesNames: dashboardData.lablesNames,
  //         totalCnt: dashboardData.totalCnt,
  //         statusNames: dashboardData.statusName,
  //         montCount: dashboardData.monthlyStatusCnt,
  //         yearCnt: dashboardData.yearStatusCnt,
  //         noOfProject: responseData.noOfProject,
  //         projectTypeTitle: responseData.projectTypeTitle,
  //         selMonthID: selMonthID,
  //         selYearID: selYearID,
  //         selmonthName: monthName,
  //         selYearName: year,
  //         loading: false,
  //       })
  //     } else {
  //       toast.error(responseData.message)
  //       setState((prev) => ({...prev, loading: false}))
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message || 'Failed to fetch project data')
  //     setState((prev) => ({...prev, loading: false}))
  //   }
  // }

  const fetchAdminCountList = async () => {
    try {
      setState((prev) => ({...prev, loading: true}))

      const response = await GetDashBoardDataForChartAndGraph_ByMonthYear_StateWiseApi(
        state.selMonthID,
        state.selYearID
      )

      const responseData: DashboardApiResponse = response.data

      if (responseData.isSuccess) {
        await newStateWiseProjectList(responseData, state.selMonthID, state.selYearID)
        // const {
        //   lablesNames,
        //   totalCnt,
        //   dailyCount,
        //   statusName,
        //   monthlyStatusCnt_GJ,
        //   yearStatusCnt_GJ,
        //   monthlyStatusCnt_MH,
        //   yearStatusCnt_MH,
        // } = responseData

        // setState((prev: any) => ({
        //   ...prev,
        //   loading: false,
        //   lablesNames,
        //   totalCnt,
        //   dailyCount,
        //   statusNames: statusName,
        //   gujaratStatus: {
        //     labels: statusName,
        //     monthlyCounts: monthlyStatusCnt_GJ,
        //     yearlyCounts: yearStatusCnt_GJ,
        //   },
        //   maharashtraStatus: {
        //     labels: statusName,
        //     monthlyCounts: monthlyStatusCnt_MH,
        //     yearlyCounts: yearStatusCnt_MH,
        //   },
        //   // Optional: update these if coming from API
        //   // gjprojectTypeTitleWithCount,
        //   // mhprojectTypeTitleWithCount,
        // }))
      } else {
        toast.error(responseData.message)
        setState((prev) => ({...prev, loading: false}))
      }
    } catch (error: any) {
      toast.error(error.message || 'Failed to fetch dashboard data')
      setState((prev) => ({...prev, loading: false}))
    }
  }

  const newStateWiseProjectList = async (
    dashboardData: DashboardApiResponse,
    selMonthID: number,
    selYearID: number
  ) => {
    try {
      const response = await getNewProjectListByMonthYearStateWise(selMonthID, selYearID)
      const responseData: NewProjectREsponse = response.data
      const apiResponse: any = response.data
      const {
        lablesNames,
        totalCnt,
        dailyCount,
        statusName,
        monthlyStatusCnt_GJ,
        yearStatusCnt_GJ,
        monthlyStatusCnt_MH,
        yearStatusCnt_MH,
      } = dashboardData

      // setState((prev: any) => ({
      //   ...prev,
      //   loading: false,
      //   lablesNames,
      //   totalCnt,
      //   dailyCount,
      //   statusNames: statusName,
      //   gujaratStatus: {
      //     labels: statusName,
      //     monthlyCounts: monthlyStatusCnt_GJ,
      //     yearlyCounts: yearStatusCnt_GJ,
      //   },
      //   maharashtraStatus: {
      //     labels: statusName,
      //     monthlyCounts: monthlyStatusCnt_MH,
      //     yearlyCounts: yearStatusCnt_MH,
      //   },
      //   // Optional: update these if coming from API
      //   // gjprojectTypeTitleWithCount,
      //   // mhprojectTypeTitleWithCount,
      // }))
      const monthName =
        selMonthID > 0 && selMonthID <= 12
          ? moment()
              .month(selMonthID - 1)
              .format('MMMM')
          : 'Unknown'
      const year = selYearID > 0 ? selYearID.toString() : 'Unknown' // Convert to string for selYearName
      if (responseData.isSuccess) {
        // Step 1: Extract unique project types in order
        const projectTypeTitle: string[] = []
        // Step 2: Create state-wise project count map per project type (indexed array)
        const stateMap: Record<number, number[]> = {}

        apiResponse.responseObject.forEach((item: any) => {
          const {stateID, projectTypeName, noOfProject} = item
          const trimmedType = projectTypeName.trim()
          const typeIndex = projectTypeTitle.indexOf(trimmedType)

          if (!stateMap[stateID]) {
            stateMap[stateID] = new Array(projectTypeTitle.length).fill(0)
          }

          if (typeIndex !== -1) {
            stateMap[stateID][typeIndex] += noOfProject
          }
        })

        // Step 3: Get Gujarat and Maharashtra project counts
        const gjNoOfProj = stateMap[1] || new Array(projectTypeTitle.length).fill(0)
        const mhNoOfProject = stateMap[15] || new Array(projectTypeTitle.length).fill(0)

        // Step 4: Build state-wise projectTypeTitleWithCount based on actual project counts
        const gjprojectTypeTitleWithCount = projectTypeTitle.map((type, index) => {
          return `${type} (${gjNoOfProj[index]})`
        })

        const mhprojectTypeTitleWithCount = projectTypeTitle.map((type, index) => {
          return `${type} (${mhNoOfProject[index]})`
        })

        // ✅ Output
        console.log('projectTypeTitle:', projectTypeTitle)
        console.log('gjprojectTypeTitleWithCount:', gjprojectTypeTitleWithCount)
        console.log('mhprojectTypeTitleWithCount:', mhprojectTypeTitleWithCount)
        console.log('gjNoOfProj:', gjNoOfProj)
        console.log('mhNoOfProject:', mhNoOfProject)

        setState({
          ...state,

          gjLabels: statusName,
          mhLabels: statusName,
          gjMonthlyCounts: (monthlyStatusCnt_GJ ?? []).map(String),
          mhMonthlyCounts: (monthlyStatusCnt_MH ?? []).map(String),
          dailyCount: dashboardData.dailyCount,
          lablesNames: dashboardData.lablesNames,
          totalCnt: dashboardData.totalCnt,
          statusNames: dashboardData.statusName,
          // montCount: dashboardData.monthlyStatusCnt,
          // yearCnt: dashboardData.yearStatusCnt,
          noOfProject: responseData.noOfProject,
          gjRespObject: gjNoOfProj,
          mhRespObject: mhNoOfProject,
          gjprojectTypeTitleWithCount: gjprojectTypeTitleWithCount,
          mhprojectTypeTitleWithCount: mhprojectTypeTitleWithCount,
          arrayStateID: responseData.stateID,
          arrayStateName: responseData.stateName,
          selMonthID: selMonthID,
          selYearID: selYearID,
          selmonthName: monthName,
          selYearName: year,
          loading: false,
        })
      } else {
        toast.error(responseData.message)
        setState((prev) => ({...prev, loading: false}))
      }
    } catch (error: any) {
      toast.error(error.message || 'Failed to fetch project data')
      setState((prev) => ({...prev, loading: false}))
    }
  }

  return (
    <>
      <div className='row gy-6 gx-xl-3'>
        <div className='d-flex flex-row justify-content-end align-items-end'>
          <div className='me-3'>
            <select
              className='form-select form-select-white'
              onChange={MonthModeValue}
              value={state.selMonthID}
            >
              <option value={0}>Select Month</option>
              {MonthDropdownData.map((data, index) => (
                <option key={index} value={data.MonthID}>
                  {data.MonthName}
                </option>
              ))}
            </select>
          </div>
          <div className='me-3'>
            <select
              className='form-select form-select-white'
              onChange={YearModeValue}
              value={state.selYearID}
            >
              <option value={0}>Select Year</option>
              {YearsDropdownData.map((data, index) => (
                <option key={index} value={data}>
                  {data}
                </option>
              ))}
            </select>
          </div>
        </div>
        {state.loading ? (
          <div className='text-center py-10'>
            <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
          </div>
        ) : (
          <>
            {/* <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <PieChartjs
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.totalCnt}
                  lablesNames={state.lablesNames}
                />
              )}
            </div>
            <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <ThisYearPieChartjs
                  className='card-xl-stretch'
                  totalCnt={state.yearCnt}
                  lablesNames={state.statusNames}
                />
              )}
            </div> */}
            <div className='col-xl-6'>
              {state.arrayStateID.includes(1) && state.gjLabels.length > 0 ? (
                <StateGujaratColumnChart
                  className='card-xl-stretch'
                  dailyCount={state.gjMonthlyCounts}
                  lablesNames={state.gjLabels}
                  selMonthID={state.selMonthID}
                  selmonthName={state.selmonthName}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-warning'>
                      <span className='text-success'></span> ({state.selmonthName}{' '}
                      {state.selYearName}) Current Month Projects
                    </span>
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div>

            {/* <div className='col-xl-4'>
              {state.arrayStateID.includes(15) && state.mhLabels.length > 0 ? (
                <StateMaharastraColumnChart
                  className='card-xl-stretch'
                  dailyCount={state.mhMonthlyCounts}
                  lablesNames={state.mhLabels}
                  selMonthID={state.selMonthID}
                  selmonthName={state.selmonthName}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-5 text-warning'>
                      <span className='text-success'>Maharashtra</span> ({state.selmonthName}{' '}
                      {state.selYearName}) This Month Projects
                    </span>
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div> */}

            {/* <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <ColumnChartjs
                  className='card-xl-stretch mb-xl-8'
                  dailyCount={state.dailyCount}
                  lablesNames={state.lablesNames}
                />
              )}
            </div> */}
            {/* start commit, for state wise colunm chart */}
            {/* <div className='col-xl-4'>
              {state.lablesNames.length > 0 && (
                <ThisMonthColumnCharts
                  className='card-xl-stretch'
                  dailyCount={state.montCount}
                  lablesNames={state.statusNames}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              )}
            </div> */}
            {/* end commit, */}
            {/* <div className='col-xl-4'>
              {state.projectTypeTitle.length > 0 && (
                <NewProjectList
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.noOfProject}
                  lablesNames={state.projectTypeTitle.map((title, index) => {
                    const count = state.noOfProject[index] ?? 0
                    return `${title} (${count})`
                  })}
                  
                />
              )}
            </div> */}

            {/* start commit, for state wise Pie chart */}

            {/* <div className='col-xl-4'>
              {state.projectTypeTitle.length > 0 ? (
                <NewProjectList
                  className='card-xl-stretch mb-xl-8'
                  totalCnt={state.noOfProject}
                  lablesNames={state.projectTypeTitle.map((title, index) => {
                    const count = state.noOfProject[index] ?? 0
                    return `${title} (${count})`
                  })}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              ) : (
                <div className='card card-xl-stretch mb-xl-8'>
                  <h3 className='card-title align-items-start flex-column mt-10 ms-9'>
                    <span className='card-label fw-bolder fs-3 text-info'>
                      {' '}
                      {state.selmonthName} {state.selYearName} New Projects
                    </span>

                    //<span className='text-muted fw-bold fs-7'>More than 400 new members</span>
                  </h3>
                  <div className='card-body d-flex align-items-center text-muted justify-content-center mb-5'>
                    <span>No Records Found</span>
                  </div>
                </div>
              )}
            </div> */}
            {/* end commit, */}
            {/* //Gujarat Pie  Chart */}
            {/*  */}
            {/* //Maharastra pie chart */}

            <div className='col-xl-6'>
              {state.lablesNames.length > 0 && (
                <SalesNameQuotCountTotal
                  className='card-xl-stretch'
                  lablesNames={state.lablesNames}
                  selMonthID={state.selMonthID}
                  selYearID={state.selYearID}
                />
              )}
            </div>
          </>
        )}
      </div>

      {/* <div className='row gy-5 g-xl-8'>
        <div className='col-xxl-12 col-12'>
          {!state.loading && state.lablesNames.length > 0 && (
            <TablesSalesQuotCount
              key={`${state.selMonthID}-${state.selYearID}`}
              className='card-xl-stretch mb-xl-8'
              lablesNames={state.lablesNames}
              selMonthID={state.selMonthID}
              selYearID={state.selYearID}
            />
          )}
        </div>
      </div>

      <div className='row gy-5 g-xl-8'>
        <div className='col-xxl-12 col-12'>
          <AdminCount
            className='card-xl-stretch mb-xl-8'
            chartColor='danger'
            chartHeight='100px'
            strokeColor='#cb1e46'
          />
        </div>
      </div> */}
    </>
  )
}
// ==============================================================================================================================
const SalesDashboardPage: FC = () => (
  <>
    <div className='row gy-5 g-xl-8'>
      <div className='col-xxl-12 col-12'>
        <SalesCountPage
          className='card-xl-stretch mb-xl-8'
          chartColor='danger'
          chartHeight='100px'
          strokeColor='#cb1e46'
        />
      </div>
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      {user.roleID == 2 || user.roleID == 1 ? (
        <AdminDashboardPage />
      ) : user.designationID === 1009 ? (
        <SalesManagerDashboardPage />
      ) : user.designationID === 1012 ? (
        <DandEHeadDashboardPage />
      ) : (
        <SalesDashboardPage />
      )}
    </>
  )
}

export {DashboardWrapper}
